import getDlpPolicyTipsOperation from 'owa-service/lib/operation/getDlpPolicyTipsOperation';
import addInfoBarMessage from '../actions/addInfoBarMessage';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import { trace } from 'owa-trace';
import { format } from 'owa-strings';
import { action } from 'satcheljs/lib/legacy';
var triggerPolicyTips = action('triggerPolicyTips')(function triggerPolicyTips(composeViewState, eventTrigger, subjectChecksum, contentChecksum, attachmentIds) {
    var policyTipsViewState = composeViewState.policyTipsViewState;
    if (policyTipsViewState.handlerDisabled || composeViewState.IRMData) {
        return;
    }
    var inProgressPolicyMatch = policyTipsViewState.inProgressPolicyMatch, succeededPolicyMatch = policyTipsViewState.succeededPolicyMatch, pendingPolicyMatch = policyTipsViewState.pendingPolicyMatch;
    if (!subjectChecksum) {
        subjectChecksum = getCheckSum(composeViewState.subject);
    }
    if (!contentChecksum) {
        contentChecksum = getCheckSum(composeViewState.content);
    }
    if (!attachmentIds) {
        attachmentIds = getAllAttachmentIds(composeViewState);
    }
    if (!policyTipsViewState.isRequestInProgress) {
        policyTipsViewState.pendingRequests = false;
        inProgressPolicyMatch.itemId = composeViewState.itemId;
        inProgressPolicyMatch.subjectChecksum = subjectChecksum;
        inProgressPolicyMatch.contentChecksum = contentChecksum;
        inProgressPolicyMatch.eventTrigger = eventTrigger;
        inProgressPolicyMatch.attachmentIds = attachmentIds;
        if (isEmptyContent(inProgressPolicyMatch)) {
            succeededPolicyMatch.policyMatchDetails = [];
            succeededPolicyMatch.subjectChecksum = 0;
            succeededPolicyMatch.contentChecksum = 0;
            succeededPolicyMatch.attachmentIds = [];
            removeInfoBarMessage(composeViewState, 'dlpPolicyTips');
            return;
        }
        // Send server request only when body or subject or attachment is changed
        if (isBodyOrSubjectChanged(inProgressPolicyMatch, succeededPolicyMatch) ||
            isAttachmentChanged(inProgressPolicyMatch, succeededPolicyMatch)) {
            getPolicyTipsData(composeViewState);
        }
    }
    else {
        policyTipsViewState.pendingRequests = true;
        pendingPolicyMatch.itemId = composeViewState.itemId;
        pendingPolicyMatch.subjectChecksum = subjectChecksum;
        pendingPolicyMatch.contentChecksum = contentChecksum;
        pendingPolicyMatch.eventTrigger = eventTrigger;
        pendingPolicyMatch.attachmentIds = attachmentIds;
    }
});
export default triggerPolicyTips;
function getPolicyTipsData(composeViewState) {
    var _a = composeViewState.policyTipsViewState, succeededPolicyMatch = _a.succeededPolicyMatch, inProgressPolicyMatch = _a.inProgressPolicyMatch;
    var itemId = composeViewState.itemId;
    if (itemId && itemId.Id) {
        var requestObject = {
            ItemId: itemId,
            ClientSupportsScanResultData: true,
            ScanResultData: succeededPolicyMatch.scanResultData,
            ScanResultMetadata: succeededPolicyMatch.scanResultMetaData,
            BodyOrSubjectChanged: isBodyOrSubjectChanged(inProgressPolicyMatch, succeededPolicyMatch),
            NeedToReclassify: !succeededPolicyMatch.itemId,
            CustomizedStringsNeeded: true,
            EventTrigger: inProgressPolicyMatch.eventTrigger,
        };
        composeViewState.policyTipsViewState.isRequestInProgress = true;
        getDlpPolicyTipsOperation(requestObject).then(function (response) {
            handleGetPolicyTipsResponse(response, composeViewState, onGetDlpPolicyTipsSucceeded, onGetDlpPolicyTipsFailed);
        });
    }
}
function handleGetPolicyTipsResponse(response, composeViewState, succeededCallback, failedCallback) {
    var policyTipsViewState = composeViewState.policyTipsViewState;
    var pendingPolicyMatch = policyTipsViewState.pendingPolicyMatch;
    policyTipsViewState.isRequestInProgress = false;
    if (policyTipsViewState.pendingRequests && pendingPolicyMatch) {
        triggerPolicyTips(composeViewState, pendingPolicyMatch.eventTrigger, pendingPolicyMatch.subjectChecksum, pendingPolicyMatch.contentChecksum, pendingPolicyMatch.attachmentIds);
    }
    if (response.EvaluationResult == 0 /* Success */ ||
        response.OptimizationResult == 1 /* NoRules */ ||
        response.EvaluationResult == 2 /* ClientErrorNoContent */) {
        succeededCallback(composeViewState, response);
    }
    else {
        failedCallback(composeViewState, response);
    }
}
function onGetDlpPolicyTipsSucceeded(composeViewState, response) {
    var policyTipsViewState = composeViewState.policyTipsViewState;
    var succeededPolicyMatch = policyTipsViewState.succeededPolicyMatch, inProgressPolicyMatch = policyTipsViewState.inProgressPolicyMatch;
    // Copy in progress data to succeeded data
    succeededPolicyMatch.itemId = inProgressPolicyMatch.itemId;
    succeededPolicyMatch.attachmentIds = inProgressPolicyMatch.attachmentIds;
    succeededPolicyMatch.subjectChecksum = inProgressPolicyMatch.subjectChecksum;
    succeededPolicyMatch.contentChecksum = inProgressPolicyMatch.contentChecksum;
    succeededPolicyMatch.policyMatchDetails = response.Matches;
    // If we're dealing with an older server it's possible that ScanResultData and DetectedClassificationIds are not present, so just ignore them in this case
    if (response.ScanResultData) {
        succeededPolicyMatch.scanResultData = response.ScanResultData;
    }
    // ScanResultMetadaData may not always be present, so just ignore it if that's the case
    if (response.ScanResultMetadata) {
        succeededPolicyMatch.scanResultMetaData = response.ScanResultMetadata;
    }
    // Stop sending further requests to server if optimization result is NoRules
    if (response.OptimizationResult == 1 /* NoRules */) {
        policyTipsViewState.handlerDisabled = true;
    }
    updatePolicyTipMessage(composeViewState);
}
function onGetDlpPolicyTipsFailed(composeViewState, response) {
    var policyTipsViewState = composeViewState.policyTipsViewState;
    if (response) {
        trace.warn(format('PolicyTips failed with EvaluationResult code of: {0}', response.EvaluationResult) +
            ' Diagnostic: ' +
            response.DiagnosticData);
        // With any of these error results, disable the PolicyTips handler for the remainder of the life of the current message
        if (response.EvaluationResult == 4 /* PermanentError */ ||
            response.EvaluationResult == 7 /* UnexpectedPermanentError */ ||
            response.EvaluationResult == 1 /* ClientErrorInvalidStoreItemId */ ||
            response.EvaluationResult == 6 /* NullOrganization */ ||
            response.EvaluationResult == 8 /* ClientErrorInvalidClientScanResult */) {
            trace.warn('Disabling further PolicyTips requests because of the failure');
            policyTipsViewState.handlerDisabled = true;
        }
    }
    else {
        trace.warn('PolicyTipsResponse is null (PolicyTipsRequest is timed out)');
        policyTipsViewState.handlerDisabled = true;
    }
    removeInfoBarMessage(composeViewState, 'dlpPolicyTips');
}
function updatePolicyTipMessage(viewState) {
    removeInfoBarMessage(viewState, 'dlpPolicyTips');
    var matchDetail = getHighestPriorityMatchDetail(viewState.policyTipsViewState.succeededPolicyMatch);
    if (matchDetail) {
        addInfoBarMessage(viewState, 'dlpPolicyTips');
    }
}
function getCheckSum(text) {
    var checkSum = 0;
    if (text) {
        for (var i = 0; i < text.length; i++) {
            checkSum += text.charCodeAt(i);
        }
    }
    return checkSum;
}
function isEmptyContent(policyMatchWrapper) {
    return (policyMatchWrapper.subjectChecksum == 0 &&
        policyMatchWrapper.contentChecksum == 0 &&
        policyMatchWrapper.attachmentIds.length == 0);
}
function getHighestPriorityMatchDetail(policyMatchWrapper) {
    var matchDetail;
    var lowestPriorityValue = 0;
    for (var i = 0; i < policyMatchWrapper.policyMatchDetails.length; i++) {
        if (policyMatchWrapper.policyMatchDetails[i].MatchPriority == 0) {
            continue;
        }
        // initialize
        if (lowestPriorityValue == 0) {
            lowestPriorityValue = policyMatchWrapper.policyMatchDetails[i].MatchPriority;
        }
        // Matches generated in unified DLP have rule priority already set (priorities starting at 1).
        // Lower priorities take precendence
        if (policyMatchWrapper.policyMatchDetails[i].MatchPriority <= lowestPriorityValue) {
            matchDetail = policyMatchWrapper.policyMatchDetails[i];
            lowestPriorityValue = policyMatchWrapper.policyMatchDetails[i].MatchPriority;
        }
    }
    if (matchDetail) {
        return matchDetail;
    }
    // For regular DLP, compute the highest priority rule
    for (var i = 0; i < policyMatchWrapper.policyMatchDetails.length; i++) {
        if (!matchDetail ||
            getActionPriority(matchDetail.Action) <
                getActionPriority(policyMatchWrapper.policyMatchDetails[i].Action)) {
            matchDetail = policyMatchWrapper.policyMatchDetails[i];
        }
    }
    return matchDetail;
}
function getActionPriority(action) {
    switch (action) {
        case 1 /* NotifyOnly */:
            return 0;
        case 4 /* RejectUnlessFalsePositiveOverride */:
            return 1;
        case 2 /* RejectUnlessSilentOverride */:
            return 1;
        case 3 /* RejectUnlessExplicitOverride */:
            return 1;
        case 5 /* RejectMessage */:
            return 2;
        default:
            return 3;
    }
}
function isBodyOrSubjectChanged(newPolicyMatchWrapper, oldPolicyMatchWrapper) {
    return (newPolicyMatchWrapper.subjectChecksum != oldPolicyMatchWrapper.subjectChecksum ||
        newPolicyMatchWrapper.contentChecksum != oldPolicyMatchWrapper.contentChecksum);
}
function getAllAttachmentIds(composeViewState) {
    var attachmentIds = [];
    var attachmentWell = composeViewState.attachmentWell;
    attachmentWell.docViewAttachments.forEach(function (attachment) {
        attachmentIds.push(attachment.attachmentId);
    });
    attachmentWell.inlineAttachments.forEach(function (attachment) {
        attachmentIds.push(attachment.attachmentId);
    });
    attachmentWell.imageViewAttachments.forEach(function (attachment) {
        attachmentIds.push(attachment.attachmentId);
    });
    return attachmentIds;
}
function isAttachmentChanged(newPolicyMatchWrapper, oldPolicyMatchWrapper) {
    if (newPolicyMatchWrapper.attachmentIds.length != oldPolicyMatchWrapper.attachmentIds.length) {
        return true;
    }
    for (var i = 0; i < newPolicyMatchWrapper.attachmentIds.length; i++) {
        if (newPolicyMatchWrapper.attachmentIds[i] != null &&
            oldPolicyMatchWrapper.attachmentIds[i] != null &&
            newPolicyMatchWrapper.attachmentIds[i].Id != oldPolicyMatchWrapper.attachmentIds[i].Id) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=triggerPolicyTips.js.map